import { render, staticRenderFns } from "./StandardSettingsPanel.vue?vue&type=template&id=be32d496&scoped=true"
import script from "./StandardSettingsPanel.vue?vue&type=script&lang=js"
export * from "./StandardSettingsPanel.vue?vue&type=script&lang=js"
import style0 from "./StandardSettingsPanel.vue?vue&type=style&index=0&id=be32d496&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be32d496",
  null
  
)

export default component.exports